// Hardcoded frontend build version, sent with every API request as
// X-App-Version (see src/axios/index.js's request interceptor) so the
// backend's App\Http\Middleware\CheckApiVersion (config('app.version'), from
// APP_VERSION in the Laravel .env) can tell an already-open, stale browser
// tab apart from a freshly-loaded one and force it to clear its cache and
// reload — see the axios response interceptor for that half.
//
// Bump this alongside the backend's APP_VERSION on any deploy where the two
// sides need to agree on something (a new required header, a breaking API
// response shape, etc.) — not every routine deploy needs a bump, only one
// where an already-open tab still acting on the old contract would matter.
export const APP_VERSION = "1.1.2";
